import { render, staticRenderFns } from "./proof-view-canvas.vue?vue&type=template&id=3a26aa6c&scoped=true&"
import script from "./proof-view-canvas.vue?vue&type=script&lang=js&"
export * from "./proof-view-canvas.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-canvas.vue?vue&type=style&index=0&id=3a26aa6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a26aa6c",
  null
  
)

export default component.exports